export const TrustateLogo = () => {
  return <img alt="trustate" src="/trustate-logo.svg" />;
};

export const ToolkitLogo = () => {
  return <img alt="toolkit" src="/toolkit_logo.svg" />;
};

export const VaultLogo = () => {
  return <img alt="valut" src="/vault_logo.svg" width="75px" />;
};
